import { lazy } from 'react'
import { stepsRoutes } from '../constants'

const IdentityData = lazy(() => import('../components/Stepper/IdentityData'))
const WelcomeRegistration = lazy(
  () => import('../components/Stepper/WelcomeRegistration'),
)
const UserFullname = lazy(() => import('../components/Stepper/UserFullname'))
const UserDate = lazy(() => import('../components/Stepper/UserDate'))
const ContactDetails = lazy(
  () => import('../components/Stepper/ContactDetails'),
)
const ChooseValidation = lazy(
  () => import('../components/Stepper/ChooseValidation'),
)
const CodeValidation = lazy(
  () => import('../components/Stepper/CodeValidation'),
)
const CardNumber = lazy(() => import('../components/Stepper/CardNumber'))
const CreateAccountError = lazy(
  () => import('../components/Stepper/CreateAccountError'),
)
const CreatePassword = lazy(
  () => import('../components/Stepper/CreatePassword'),
)
const HealthPlan = lazy(() => import('../components/Stepper/HealthPlan'))
const ValidateUserData = lazy(
  () => import('../components/Stepper/ValidateUserData'),
)
const CreateAccountSuccess = lazy(
  () => import('../components/Stepper/CreateAccountSuccess'),
)
const HolderDependent = lazy(
  () => import('../components/Stepper/HolderDependent'),
)
const ChooseHealthPlan = lazy(
  () => import('../components/Stepper/ChooseHealthPlan'),
)

const ActivationPending = lazy(
  () => import('../components/Stepper/ActivationPending'),
)

const OtherHealthPlan = lazy(
  () => import('../components/Stepper/OtherHealthPlan'),
)

export const getComponents = (name: string): React.ReactNode => {
  return {
    [stepsRoutes.START]: <WelcomeRegistration />,
    [stepsRoutes.CPF]: <IdentityData />,
    [stepsRoutes.ACTIVATION_PENDING]: <ActivationPending />,
    [stepsRoutes.NAME]: <UserFullname />,
    [stepsRoutes.BIRTHDATE]: <UserDate />,
    [stepsRoutes.CONTACT_DETAILS]: <ContactDetails />,
    [stepsRoutes.CHOOSE_VALIDATION]: <ChooseValidation />,
    [stepsRoutes.CODE_VALIDATION_SMS]: (
      <CodeValidation screen="resendCodeSms" />
    ),
    [stepsRoutes.CODE_VALIDATION_MAIL]: (
      <CodeValidation screen="resendCodeEmail" />
    ),
    [stepsRoutes.CHOOSE_HEALTH_PLAN]: <ChooseHealthPlan />,
    [stepsRoutes.OTHER_HEALTH_PLAN]: <OtherHealthPlan />,
    [stepsRoutes.HEALTH_PLAN]: <HealthPlan />,
    [stepsRoutes.CARD_NUMBER]: <CardNumber />,
    [stepsRoutes.HOLDER_OR_DEPENTENT]: <HolderDependent />,
    [stepsRoutes.VALIDATE_USER_DATA]: <ValidateUserData />,
    [stepsRoutes.CREATE_PASSWORD]: <CreatePassword />,
    [stepsRoutes.CREATED_ACCOUNT_SUCCESS]: <CreateAccountSuccess />,
    [stepsRoutes.CREATE_ACCOUNT_ERROR]: <CreateAccountError />,
  }[name]
}
